import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../../../shared/components/loader/linearProgress";
import { getLocalStorageData } from "../../../../shared/utils/localStorage";

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      if (getLocalStorageData("userData")) {
        navigate("/dashboard");
      } else {
        navigate("/login");
      }
    };

    fetchData();
  }, [navigate]);

  return <Loader />;
};

export default Home;
